var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteClosing = function SvgQuoteClosing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.807 8.911a.25.25 0 0 1-.25-.25V.25A.25.25 0 0 1 .807 0h8.721a.25.25 0 0 1 .25.25v9.615c0 4.394-3.522 7.998-7.885 8.131a.245.245 0 0 1-.25-.246v-4c0-.138.112-.25.25-.258a3.638 3.638 0 0 0 3.385-3.627V9.16a.25.25 0 0 0-.25-.25H.807Z",
    fill: "currentColor"
  })));
};
export default SvgQuoteClosing;